import { render, staticRenderFns } from "./MMClicksPie.vue?vue&type=template&id=4bb9fbf9&scoped=true&"
import script from "./MMClicksPie.vue?vue&type=script&lang=js&"
export * from "./MMClicksPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9fbf9",
  null
  
)

export default component.exports